export default __webpack_public_path__ + "static/media/People.38ebd552.svg";